<div class="container">
  <div class="row justify-content-center align-items-center min-vh-100">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <div class="col-12 text-cont-fl text-center">
        <img class="logo-img" src="assets/img/dnvlogo.png" alt="DNV Logo" />
      </div>
      <mat-card>
        <mat-card-content>
          <form #loginForm="ngForm" (ngSubmit)="login()">
            <h2 class="login">Login Here</h2>
            <mat-error *ngIf="!loginValid" class="d-block">
              The username and password were not recognized
            </mat-error>
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Enter your UserName</mat-label>
              <input matInput placeholder="Enter your username" [(ngModel)]="username" name="username" required>
              <mat-error>
                Please provide a valid username
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Enter your password</mat-label>
              <input matInput [(ngModel)]="password" name="password" [type]="hide ? 'password' : 'text'" required (keydown.enter)="login()">
              <mat-error>
                Please provide a valid password
              </mat-error>

              <button mat-icon-button matSuffix type="button" (click)="toggleHide()" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>              
            </mat-form-field>
                        
            <button class="login-btn" type="submit" [disabled]="!loginForm.form.valid">
              Login
          </button>
          

          </form>
        </mat-card-content>
      </mat-card>
      <div class="container text-center"> 
        <div class="row">
            <footer class="col-sm-12 mt-0 p-2">
                <p style="font-weight: bold; color: #005050;">Powered by:</p>
                <img src="assets/img/Picture10.png" alt="Powered by Logo" style="mix-blend-mode: multiply; display: block; margin: 0 auto; max-width: 100%; height: auto;" />
            </footer>
        </div>
      </div>
    </div>
  </div>
</div>